import React, { useEffect, useState } from "react";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import LoaderContainer from "../../../../Reusable/LoaderContainer/LoaderContainer.js";
import Pagination from "../../../../Reusable/Pagination/Pagination.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import DisplayFormMails from "./DisplayFormMails.js";
import ReportsInputs from "./ReportsInputs.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { exportMailsToFile } from "./ApiRequests.js";
import { useParams } from "react-router-dom";

const ActivityReports = ({ userData, dynamicFormsList }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sentMailsCount, setSentMailsCount] = useState(0);
  const { getTextByKey, getLanguageCulture } = useContent();
  const [loading, setLoading] = useState(false);
  const [exportMails, setExportMails] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFormArray, setSelectedFormArray] = useState([]);
  const [selectedFormNameArray, setSelectedFormNameArray] = useState([]);
  const [showFormsList, setshowFormsList] = useState(false);
  const [showStatusesList, setShowStatusesList] = useState(null);
  const [allTime, setAllTime] = useState(false);
  const [displayDatepicker, setDisplayDatepicker] = useState(false);
  const params = useParams();
  const [loadingExports, setLoadingExports] = useState(false);

  const fileTypes = ["csv", "txt", "xml", "excel"];

  //Check if redirect from "form-management/form-id"
  useEffect(() => {
    if (params) {
      if (params.dynamicformid) {
        if (params.dynamicformid !== undefined) {
          if (dynamicFormsList.length > 0) {
            let temp = dynamicFormsList.filter(
              (item) => item.Embed_Dynamic_Id == params.dynamicformid
            );
            if (temp.length > 0) {
              let arr = [];
              arr.push(temp[0].Embed_Dynamic_Id);
              setSelectedFormArray(arr);
              let arrNames = [];
              arrNames.push(temp[0].Embed_Dynamic_Inner_Title);
              setSelectedFormNameArray(arrNames);
              let last30days = new Date();
              let today = new Date();
              last30days.setDate(new Date().getDate() - 30);
              setStartDate(last30days);
              setEndDate(today);
              GetExportMails(arr[0], last30days, today);
            }
          }
        }
      }
    }
  }, [params, dynamicFormsList]);

  //display dates selected if select all time dates
  useEffect(() => {
    if (allTime && !displayDatepicker) {
      setStartDate(new Date(userData.RegisterationDate));
      setEndDate(new Date());
      setAllTime(false);
    }
  }, [displayDatepicker]);

  //Show Data of export mails
  const showData = (current) => {
    if (selectedFormArray.length > 1) {
      let multipleList = [];
      for (let i = 0; i < selectedFormArray.length; i++) {
        const element = selectedFormArray[i];
        multipleList.push({
          EmbedFormId: element,
          StartDate: startDate,
          EndDate: endDate,
          Index: current,
        });
      }
      GetMultipleExportMails(multipleList);
    } else if (selectedFormArray.length === 1) {
      GetExportMails(selectedFormArray[0], startDate, endDate);
    }
  };

  //if selected more than one form
  const GetMultipleExportMails = async (list) => {
    setLoading(true);
    const body = list;
    const response = await apiRequest(
      "EmbedDynamics",
      "GetMultipleExportMails",
      body,
      "POST"
    );
    if (response.status === "success") {
      setExportMails(response.data.SentMails);
      setSentMailsCount(response.data.SentMailsCount);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  function up(v, n) {
    return Math.ceil(v * Math.pow(10, n)) / Math.pow(10, n);
  }

  //if selected one form
  const GetExportMails = async (id, startDate, endDate) => {
    setLoading(true);
    const body = {
      EmbedFormId: id,
      StartDate: startDate,
      EndDate: endDate,
      Index: currentPage,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetExportMails",
      body,
      "POST"
    );
    if (response.status === "success") {
      setExportMails(response.data.SentMails);
      setSentMailsCount(response.data.SentMailsCount);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  //if change num page in pagination
  useEffect(() => {
    if (selectedFormArray.length > 0) {
      showData(currentPage);
    }
  }, [currentPage]);

  //select the froms to show data
  const handleChangeSelectedArray = (item) => {
    selectedFormArray.includes(item.Embed_Dynamic_Id)
      ? setSelectedFormArray((prev) =>
          prev.filter((item2) => item2 !== item.Embed_Dynamic_Id)
        )
      : setSelectedFormArray((prev) => [...prev, item.Embed_Dynamic_Id]);

    selectedFormNameArray.includes(item.Embed_Dynamic_Inner_Title)
      ? setSelectedFormNameArray((prev) =>
          prev.filter((item2) => item2 !== item.Embed_Dynamic_Inner_Title)
        )
      : setSelectedFormNameArray((prev) => [
          ...prev,
          item.Embed_Dynamic_Inner_Title,
        ]);
  };

  const exportMailCountText = (text, itemToReplace) => {
    let temp = text.replace("#sentMailsCount#", itemToReplace);
    return temp;
  };
  return (
    <div className="activity-container">
      <div className="embed-page-title">
        <h3>{getTextByKey("profile-menu-jumboform-activity-reports")}</h3>
      </div>
      {dynamicFormsList.length > 0 ? (
        <>
          <ReportsInputs
            setDisplayDatepicker={setDisplayDatepicker}
            displayDatepicker={displayDatepicker}
            allTime={allTime}
            setAllTime={setAllTime}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            dynamicFormsList={dynamicFormsList}
            selectedFormArray={selectedFormArray}
            setSelectedFormArray={setSelectedFormArray}
            setshowFormsList={setshowFormsList}
            selectedFormNameArray={selectedFormNameArray}
            setSelectedFormNameArray={setSelectedFormNameArray}
            showData={showData}
            loading={loading}
            setCurrentPage={setCurrentPage}
            showFormsList={showFormsList}
            handleChangeSelectedArray={handleChangeSelectedArray}
            exportMails={exportMails}
            setExportMails={setExportMails}
            setShowStatusesList={setShowStatusesList}
          />
          <div className="export-mails">
            {!loading && exportMails && exportMails.length > 0 ? (
              <div className="top-header">
                <div className="left-side">
                  {exportMailCountText(
                    getTextByKey("export-mails-count"),
                    sentMailsCount
                  )}
                </div>
                <div className="right-side">
                  {loadingExports && <LoadingImageElement />}
                  <div className="export-types">
                    {" "}
                    {getTextByKey("export-file-type")}:{" "}
                    {fileTypes.map((item, i) => (
                      <span
                        key={i}
                        onClick={() => {
                          exportMailsToFile(
                            item,
                            selectedFormArray,
                            startDate,
                            endDate,
                            getLanguageCulture(),
                            setLoadingExports
                          );
                        }}
                      >
                        {item.toUpperCase()}
                        {i + 1 !== fileTypes.length ? " | " : null}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ) : null}
            {!loading && exportMails && exportMails.length > 0 ? (
              exportMails.map((item, i) => (
                <DisplayFormMails
                  key={i}
                  index={i}
                  item={item}
                  selectedFormArray={selectedFormArray}
                  selectedFormNameArray={selectedFormNameArray}
                  setDisplayDatepicker={setDisplayDatepicker}
                  setshowFormsList={setshowFormsList}
                  showStatusesList={showStatusesList}
                  setShowStatusesList={setShowStatusesList}
                />
              ))
            ) : !loading && exportMails && exportMails.length === 0 ? (
              <div className="empty-mails">
                {" "}
                <div className="empty-forms-container">
                  <div className="">
                    <Icon
                      iconClass="no-forms-img"
                      name="no-forms"
                      xxxl="true"
                    />
                  </div>
                  <div className="no-forms-text">
                    {getTextByKey("embed-export-no-mails")}
                  </div>
                </div>
              </div>
            ) : null}
            {!loading && exportMails && sentMailsCount > 10 ? (
              <Pagination
                maxPages={up(sentMailsCount / 10, 0)}
                currentPage={currentPage}
                maxPerPage={10}
                setCurrentPage={setCurrentPage}
              />
            ) : null}
          </div>
        </>
      ) : null}
      <div className={loading ? "" : "non-active"}>
        <LoaderContainer isLoading={loading} />
      </div>
    </div>
  );
};

export default ActivityReports;
